import TLogout from '../../templates/logout';

function Logout() {
  return <TLogout></TLogout>;
}

export default Logout;
